"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionButton_1 = require("../ActionButton/ActionButton");
exports.CommandButton = ActionButton_1.ActionButton;
//# sourceMappingURL=CommandButton.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Button/CommandButton/CommandButton.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Button/CommandButton/CommandButton.js
// module chunks = 1